export default __webpack_public_path__ + "static/media/g2022-30.e132189d.jpeg";